module.exports = __webpack_public_path__ + "img/yyzz.2dec1cd4.png";